import { getString, setString } from '../../lib/local-storage/interface-base';

export const STUDIO_ID = 'GAME_STUDIO_ID';
export const STUDIO_NAME = 'GAME_STUDIO_NAME';

export function getLocalStorageStudioId(): string | null {
  if (getString(STUDIO_ID)) {
    return getString(STUDIO_ID);
  }
  return '';
}

export function setLocalStorageStudioId(value: string) {
  return setString(STUDIO_ID, value);
}

export function setLocalStorageStudioName(value: string) {
  return setString(STUDIO_NAME, value);
}
